import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  snapLastPaper,
  unSnapLastPaper,
} from "store/bailiff/(default)/paper/default_paper.action";
import { isLoggedSelector } from "store/bailiff/auth/bailiff_auth.selector";
//
//component
//redux
//selector
//actions
const TriggerPrivate = () => {
  // -------------------------- VAR ----------------------------
  // -------------------------- STATE --------------------------
  // -------------------------- REDUX --------------------------
  const dispatch = useDispatch();
  const logged = useSelector(isLoggedSelector);
  // -------------------------- USE EFFECT ---------------------
  useEffect(() => {
    if (logged) {
      dispatch(snapLastPaper());
    }

    return () => dispatch(unSnapLastPaper());
  }, [dispatch, logged]);
  // -------------------------- RETURN --------------------------
  return <></>;
};
export default TriggerPrivate;
